import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Warehouse from "../../../containers/modules/master/warehouse";

export default function WarehouseRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="warehouse"
      index
      element={
        <AccessControl
          name={"Warehouse List"}
          auth={authUser}
          component={() => <Warehouse authUser={authUser} />}
        />
      }
    />
  );
}
